import { Message } from "@chatscope/chat-ui-kit-react";
import { MessageDirection } from "@chatscope/use-chat";
import moment from "moment";
import { Key } from "react";
import { classNames } from "../../helpers";

type MessagesProps = {
  messageList: {
    messages: {
      id: Key | null | undefined;
      content: any;
      senderId: string | undefined;
    }[];
  };
  direction: MessageDirection;
};
export const MessageContainer = (props: MessagesProps) => {
  const { messageList, direction } = props;
  return (
    <>
      {messageList.messages.map((message: any) => {
        const payloadContent =
          message?.contentType === 6
            ? {
                src: message.content,
                alt: "file chat",
                width: "100%",
              }
            : message.content;

        return (
          <div
            className={classNames(
              "w-full sm:flex",
              message?.direction === "outgoing"
                ? "sm:justify-end"
                : "sm:justify-start"
            )}
            key={message?.id}
          >
            <div className="w-full   sm:min-w-[288px] sm:max-w-full  sm:w-[calc(50%+32px)]  flex flex-col  gap-1">
              <div
                className={classNames(
                  "w-full flex  text-gray-400 text-xs leading-5",
                  message?.direction === "outgoing"
                    ? "justify-end"
                    : "justify-start"
                )}
              >
                {moment(message?.createdTime).fromNow()}
              </div>
              <div
                className={classNames(
                  "w-full flex flex-col ",
                  message?.direction === "outgoing"
                    ? "items-end"
                    : "items-start"
                )}
              >
                <Message
                  type={message?.contentType === 6 ? "image" : "text"}
                  model={{
                    position: "single",
                    direction,
                    payload: payloadContent,
                    sender: `${message?.senderId}` ?? "",
                  }}
                  className={classNames(
                    "w-fit max-w-full p-2.5 text-sm  overflow-x-hidden break-normal",
                    message?.direction === "outgoing"
                      ? "bg-brandblue-600 text-white rounded-2xl rtl:rounded-tl-none ltr:rounded-tr-none"
                      : "text-gray-700 bg-gray-100 rounded-2xl ltr:rounded-tl-none rtl:rounded-tr-none"
                  )}
                />
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};
